import { Group } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import DataWrapper from "../../../../common/components/DataWrapper/DataWrapper";
import { filterOptions, sortOptions } from "../../utils/masterCovers";
import useRbac from "../../../../common/hooks/useRbac/useRbac"; 

const MasterCover = () => {
  const { checkPermission } = useRbac(); 
  const navigate = useNavigate();

  const endpoint = "cover-api/master-covers/";

  const handleView = (row) => `${row.id}`;
  const handleEdit = (row) => `edit/${row.id}`;
  const handlePricesView = (row) => `${row.id}/pricing/`;
  const handleBenefitsView = (row) => `${row.id}/benefits/`;

  const config = {
    fields: [
      { key: "token", label: "Plan Code" },
      { key: "title", label: "Plan Title" },
      { key: "cover_scope", label: "Geo Scope" },
      // { key: "currency", label: "Currency" },
      { key: "partner_name", label: "Premium Partner" },
      { key: "is_expired", label: "Status", type: "status" },
      // { key: "created_on", label: "Date", type: "datetime" },
    ],
    actions: [
      { label: "View", to: (row) => handleView(row) },
      ...(checkPermission("update") ? [{ label: "Edit", to: (row) => handleEdit(row) }] : []),
      { label: "Price", to: (row) => handlePricesView(row) },
      { label: "Benefits", to: (row) => handleBenefitsView(row) },
    ],
    selectionActions: checkPermission("create")
    ? [
        {
          label: "+ Add Master Plan",
          handler: () => {
            navigate("create");  
          },
        },
      ]
    : [],
    rowClickTo: (row) => handleView(row),
    doubleClickRow: true,
  };

  return (
    <>
    <Group align="center" gap="sm">
    </Group>
      <DataWrapper
        endpoint={endpoint}
        filterOptions={filterOptions}
        sortOptions={sortOptions}
        config={config}
        swrConfig={{ revalidateOnFocus: false, revalidateOnReconnect: false }}
      />
    </>
  );
};

export default MasterCover;